// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gf-0";
export var actionModalContentContainer = "_gf-1";
export var createTagButton = "_gf-2";
export var footerContainer = "_gf-7";
export var fullWidthDivider = "_gf-3";
export var hasCreateTagButton = "_gf-4";
export var noCreateTagButton = "_gf-5";
export var tagsContainer = "_gf-6";
export var tagsModalContentContainer = "_gf-8";